import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import type { MappedChartRow } from '@/features/Dashboard/types/types';

import DashboardCard from './DashboardCard';
import DashboardRowDropzoneGroup from './DashboardRowDropzoneGroup';

type DashboardRowGroupProps = {
  rowIndex: number;
  row: MappedChartRow;
  dashboardId: string;
  someDragging: boolean;
  setSomeDragging: (someDragging: boolean) => void;
  rowHeight: string;
};

export const GRID_GAP = 0;

const DashboardRowGroup = (props: DashboardRowGroupProps) => {
  const [key, setKey] = useState<string>(props.row.id);

  const chartsDeps = useMemo(() => {
    return props.row.columns
      ?.map((col) => col.chart?.alias)
      .filter((d) => d)
      .join(',');
  }, [props.row.columns]);

  // Drag & Drop 으로 내부 컴포넌트가 변경되었을 때, key를 변경하여 리마운트
  useEffect(() => {
    const randomKey = Math.random().toString(36).substring(7);
    setKey(randomKey);
  }, [chartsDeps]);

  const cardWidth = `calc(100% / ${props.row.columns?.length} - ${GRID_GAP}px)`;

  return (
    <StyledDashboardRowChartGroup
      key={key}
      id={props.row.id}
      a="stretch"
      style={{ height: props.rowHeight }}
    >
      {props.row.columns?.map((col, i) => (
        <DashboardCard
          key={col.id}
          index={i}
          rowIndex={props.rowIndex}
          dashboardId={props.dashboardId}
          rowId={props.row.id}
          column={col}
          someDragging={props.someDragging}
          setSomeDragging={props.setSomeDragging}
          width={cardWidth}
        />
      ))}

      {props.row.columns && (
        <DashboardRowDropzoneGroup
          dashboardId={props.dashboardId}
          rowId={props.row.id}
          someDragging={props.someDragging}
          columns={props.row.columns}
        />
      )}
    </StyledDashboardRowChartGroup>
  );
};

const StyledDashboardRowChartGroup = styled(Flex).attrs({
  g: GRID_GAP,
})`
  position: relative;
`;

export default DashboardRowGroup;
